__turbopack_context__.v({
  "item": "style-module-scss-module__7oZJRq__item",
  "item__subtitle": "style-module-scss-module__7oZJRq__item__subtitle",
  "item__title": "style-module-scss-module__7oZJRq__item__title",
  "root": "style-module-scss-module__7oZJRq__root",
});
